import useMutationApi from 'src/api/useMutationApi';

interface Body {
  code: string;
  state?: string;
}

export const useWorkOSCallback = (onSuccess?: () => void) => {
  return useMutationApi<Body>({
    endpoint: 'auth/workos/callback',
    method: 'POST',
    options: {
      onSuccess,
    },
    showSuccessToast: false,
    showErrorToast: false,
  });
};
